import { render } from "./TransferSuggest.vue?vue&type=template&id=eb127d0a&scoped=true"
import script from "./TransferSuggest.vue?vue&type=script&lang=js"
export * from "./TransferSuggest.vue?vue&type=script&lang=js"

import "./TransferSuggest.vue?vue&type=style&index=0&id=eb127d0a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb127d0a"]])

export default __exports__